<template>
  <nav class="d-flex flex-column justify-content-center">
    <div class='d-flex align-items-center items'>
      <span class="d-flex align-items-center option" :class="{active: value === 'BaseConfig'}" @click="$emit('input', 'BaseConfig')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
        </svg>
        <span class="ml-1">
          Base config
        </span>
      </span>
      <span class="d-flex align-items-center option" :class="{active: value === 'BlockContents'}" @click="$emit('input', 'BlockContents')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
          <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
        </svg>
        <span class="ml-1">
          Blocks
        </span>
      </span>
      <span class="d-flex align-items-center option" :class="{active: value === 'Pages'}" @click="$emit('input', 'Pages')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
          <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
        </svg>
        <span class="ml-1">
          Pages
        </span>
      </span>
      <span class="d-flex align-items-center option" :class="{active: value === 'Backups'}" @click="$emit('input', 'Backups')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
          <path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" />
        </svg>
        <span class="ml-1">
          Backups
        </span>
      </span>
    </div>
    <div class="langs">
      <span class='lang-option' :class='{activeLang: selectedLang === "default"}' @click='$emit("set-lang", "default")'>
        English
      </span>
      <span class='lang-option' :class='{activeLang: selectedLang === "nl_NL"}' @click='$emit("set-lang", "nl_NL")'>
        Dutch
      </span>
    </div>
  </nav>
</template>

<script>

export default {
  props: ["value", "selectedLang"],
}

</script>

<style scoped>

nav {
  border-bottom: 1px solid rgba(238, 238, 238);
  height: 70px;
  position: sticky;
  top: 0;
  background-color: white;
  padding: 0 14px;
  z-index: 20;
}

.lang-option {
  cursor: pointer;
  border-radius: 4px;
  padding: 4px 6px;
  border: 1px solid rgba(238, 238, 238);
  transition-duration: .15s;

}

.langs {
  margin-top: 12px;
}

.activeLang {
  border: 1px solid var(--green);
  background-color: var(--green) !important;
  color: white;
}

.lang-option:hover {
  background-color: rgb(248,248,248);
}

.items > span + span {
  margin-left: 12px;
}

.langs > span + span {
  margin-left: 8px;
}

.option, svg {
  cursor: pointer;
  transition-duration: .15s;
}

svg {
  color: rgba(140,140,140);
}

.option:hover, .option:hover svg, .option.active, .option.active svg {
  color: var(--primary) !important;
}

</style>
